<template>
	<v-container fill-height>
		<v-card max-width="400" class="mx-auto">
			<v-card-text class="text-center">
				The directory is not available. Contact the owner
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: "ExpiredOwner",
};
</script>